//zoom effect on image hover

$(document).ready(function () {
    let newestOfferImage = $('.newest-offers .offer-image');
    newestOfferImage.hover( function () {
        $(this).children('.offer-image-inner').toggleClass('zoomed');
    });
});